module.exports = __webpack_public_path__ + "img/Delivery.589f18e2.png";